<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row d-flex justify-content-center">
        <div class="col-xl-7">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div class="row d-flex justify-content-center">
                    <div
                      class="dataTables_paginate paging_full_numbers"
                      id="datatable_paginate"
                    >
                      <ul class="pagination">
                        <li
                          class="paginate_button page-item"
                          v-for="key in countPage"
                          :key="key"
                          v-bind:class="{ active: key == currentPage }"
                        >
                          <a
                            href="#"
                            aria-controls="datatable"
                            data-dt-idx="3"
                            tabindex="0"
                            class="page-link"
                            @click="changePage(key)"
                          >
                            {{ key }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  id="datatable_wrapper"
                  class="dataTables_wrapper container-fluid dt-bootstrap4"
                  style="margin-bottom: 10px !important"
                >
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <div
                        class="dataTables_length"
                        id="datatable_length"
                      ></div>
                    </div>

                    <div class="col-sm-12 col-md-6">
                      <div
                        id="datatable_filter"
                        class="dataTables_filter"
                      ></div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <a href="#" class="card-drawing" @click="getBigDrawing()">
                        <img
                          src="../assets/img/drawprewiew.jpg"
                          v-if="!showPdf"
                        />
                        <pdf
                          v-if="showPdf"
                          ref="myPdfComponent"
                          :src="url"
                          :page="currentPage"
                          class="pdf-viewer__preview"
                          style="display: inline-block; width: 150%"
                        ></pdf>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row d-flex justify-content-center">
                    <div class="dataTables_paginate paging_full_numbers">
                      <ul class="pagination">
                        <li
                          class="paginate_button page-item"
                          v-for="item in listFiles"
                          v-bind:class="{
                            active: item.nameFile == currentFile,
                          }"
                        >
                          <a
                            href="#"
                            aria-controls="datatable"
                            style="font-size: 12px"
                            data-dt-idx="3"
                            tabindex="0"
                            class="page-link"
                            @click="changeFile(item.nameFile, item.dataPDF)"
                          >
                            {{ item.nameFile }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- end content-->
              </div>
              <!--  end card  -->
            </div>
            <!-- end col-md-12 -->
          </div>
        </div>
      </div>
    </div>

    <modal
      name="big-drawing"
      style="z-index: 10000"
      draggable=".window-header"
      :adaptive="true"
      :delay="300"
      :height="'80%'"
      :width="'80%'"
      :resizable="true"
      class="card-drawing"
    >
      <div class="window-header">
        <div slot="top-right">
          <button @click="$modal.hide('big-drawing')">
            <i class="nc-icon nc-simple-remove"></i>
          </button>
        </div>
      </div>

      <div class="card">
        <pdf ref="myPdfComponent" :src="url" :page="currentPage"></pdf>
      </div>
    </modal>
    <loader :is-visible="isLoading"></loader>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import Loader from "../components/Loader.vue";

export default {
  name: "DisplayDrawing",
  components: {
    pdf,
    Loader,
  },
  data() {
    return {
      url: "",
      documentError: undefined,
      enableUploader: false,
      pages: [],
      currentPage: 1,
      countPage: 0,
      currentFile: 0,
      i: 1,
      showPdf: false,
      isActive: false,
      isShowArticle: false,
      isShowNomenclature: false,
      isShowDrawing: false,
      isLoading: false,

      items: [],
      options: {
        multiple: true,
        checkbox: false,
      },
      filter: {
        plainList: true,
      },
      drawingRequest: {
        article: "",
        designerName: "",
        nomenclature: "",
        organization: "",
        session: "",
      },

      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },

      listForArticles: [],
      listForDrawing: [],
      listForNomenclature: [],
      listFiles: [],
    };
  },
  mounted() {
    localStorage.removeItem("user-token");
    localStorage.removeItem("ip");
    localStorage.removeItem("name");
    localStorage.removeItem("role");
    localStorage.removeItem("user");

    this.drawingRequest.article = this.$route.query.article;

    if (this.$route && this.$route.query && this.$route.query.token) {
      this.drawingRequest.session = this.$route.query.token;
      localStorage.setItem("user-token", this.$route.query.token);
    }

    console.log(this.drawingRequest);
    this.getDrawingPdf(this.drawingRequest.article);
    //http://draw.modern-expo.info/displaydraw?article=1024-820-16&token=7a4c3e96-250a-4265-990f-201a6b45629b
  },

  destroyed() {},

  methods: {
    findArticle() {
      this.drawingRequest.session = localStorage.getItem("user-token");
      axios
        .post("/drawing/find-article", {
          drawingRequest: this.drawingRequest,
        })
        .then((res) => {
          this.listForArticles = res.data;
          this.isShowArticle = true;
        })
        .catch((e) => {});
    },

    findNomenclature() {
      this.drawingRequest.session = localStorage.getItem("user-token");
      axios
        .post("/drawing/find-article", {
          drawingRequest: this.drawingRequest,
        })
        .then((res) => {
          this.listForNomenclature = res.data;
          this.isShowNomenclature = true;
        })
        .catch((e) => {});
    },

    findDesignName() {
      this.drawingRequest.session = localStorage.getItem("user-token");
      axios
        .post("/drawing/find-article", {
          drawingRequest: this.drawingRequest,
        })
        .then((res) => {
          console.log(res);
          this.listForDrawing = res.data;
          this.isShowDrawing = true;
        })
        .catch((e) => {});
    },

    selectArticle(item) {
      this.drawingRequest.article = item.article;
      this.drawingRequest.nomenclature = item.names;
      this.drawingRequest.designerName = item.designername;
      this.listForArticles = [];
      this.isShowArticle = false;
    },

    selectNomenclature(item) {
      this.drawingRequest.article = item.article;
      this.drawingRequest.nomenclature = item.names;
      this.drawingRequest.designerName = item.designername;
      this.listForNomenclature = [];
      this.isShowNomenclature = false;
    },

    selectDesignName(item) {
      this.drawingRequest.article = item.article;
      this.drawingRequest.nomenclature = item.names;
      this.drawingRequest.designerName = item.designername;
      this.listForDrawing = [];
      this.isShowDrawing = false;
    },

    findDrawing() {
      console.log("findDrawing");
      this.isLoading = true;
      this.clearPdfView();
      this.drawingRequest.session = localStorage.getItem("user-token");
      axios
        .post("/drawing/getTreeStructure", {
          drawingRequest: this.drawingRequest,
        })
        .then((res) => {
          if (res.data != null) {
            const list = res.data[0];
            const tree = this.$refs.tree.tree;
            let model = tree.setModel(list);
            //this.$set(this.$refs.tree, "model", model);
          } else {
            this.showNotify(
              "error",
              "Error",
              "Структуру по даному артикулу не знайдено."
            );
          }

          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
          this.showNotify("error", "Error", e);
        });
    },

    getDrawingPdf(article) {
      this.isLoading = true;
      this.drawingRequest.article = article;
      this.drawingRequest.session = localStorage.getItem("user-token");
      axios
        .post("/drawing/getDrawingPdf", {
          drawingRequest: this.drawingRequest,
        })
        .then((res) => {
          if (res.data.status) {
            this.listFiles = res.data.list;
            this.showPdf = true;
            this.url = "";
            this.url =
              "data:application/pdf;base64," + res.data.list[0].dataPDF;
            this.currentFile = res.data.list[0].nameFile;
            let loadingTask = pdf.createLoadingTask(this.url);
            loadingTask.then((pdf) => {
              this.countPage = pdf.numPages;
              this.isLoading = false;
            });
          } else {
            this.isLoading = false;
            this.clearPdfView();
            this.showNotify("error", "Error", res.data.error);
          }
        })
        .catch((e) => {
          this.isLoading = false;
          this.showNotify("error", "Error", e);
        });
    },

    changePage(numPage) {
      this.isLoading = true;
      this.currentPage = numPage;
      this.isLoading = false;
    },

    changeFile(file, dataPDF) {
      this.url = "data:application/pdf;base64," + dataPDF;
      let loadingTask = pdf.createLoadingTask(this.url);
      loadingTask.then((pdf) => {
        this.countPage = pdf.numPages;
        this.currentFile = file;
      });
    },

    clearPdfView() {
      console.log("clearPdfView");
      this.showPdf = false;
      this.listFiles = [];
      this.url = "";
    },

    downloadDrawingPdf() {},

    getBigDrawing() {
      this.show();
    },

    show() {
      this.$modal.show("big-drawing", {
        title: "Drawing!",
        text: "You are too awesome",
        buttons: [
          {
            title: "Close",
          },
        ],
      });
    },

    hide() {
      this.$modal.hide("hello-world");
    },

    showNotify(group, title, messages) {
      this.$notify({
        group: group,
        title: title,
        text: messages,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/DisplayDraw.vue